import { useFn } from '@eturi/react'
import { useEffect } from 'react'
import { useBackHistory } from './useBackHistory.js'

export const useBackHistoryOnClose = (enabled: boolean, onClose: () => void | false) => {
	const backHistory = useBackHistory()
	const onBack = useFn(onClose)

	useEffect(() => {
		if (!enabled) return

		return backHistory.register(onBack)
	}, [enabled])
}
